import React from 'react';
import styles from './PrintPetVaccines.module.scss';
import Pet from '@spike/pet-model';
import moment from 'moment-timezone';

type Props = {
    pet: Pet;
};

const PrintPetVaccines: React.FC<Props> = ({ pet }) => {
    const vaccines = pet?.medicalHistory?.vaccines ?? [];

    if (!vaccines || vaccines.length === 0) {
        return (
            <div className={styles.section}>
                <div className={styles.sectionTitle}>Vaccines</div>
                <div className={styles.empty}>No vaccines added yet.</div>
            </div>
        );
    }

    return (
        <div className={styles.section}>
            <div className={styles.sectionTitle}>Vaccines</div>
            <ul className={styles.vaccinesList}>
                {vaccines.map((v: any, idx: number) => (
                    <li
                        key={v.uuid ?? idx}
                        className={styles.vaccineRow}
                    >
                        <span className={styles.vaccineName}>{v.type?.name ?? v.name ?? 'Vaccine'}:</span>{' '}
                        <span className={styles.vaccineMeta}>
                            {v.expiration ? (
                                <>
                                    Expires on {moment(v.expiration).format('MM/DD/YYYY')}
                                    {v.status ? <strong className={styles.status}> ({v.status})</strong> : ''}
                                </>
                            ) : (
                                <span className={styles.missing}>Missing Expiration Date</span>
                            )}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PrintPetVaccines;
